import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { C, FONT } from '../theme/tokens';
import FumehoodOverviewScreen from '../screens/fumehood/FumehoodOverviewScreen';
import FumehoodTypesScreen from '../screens/fumehood/FumehoodTypesScreen';
import FumehoodCalculationsScreen from '../screens/fumehood/FumehoodCalculationsScreen';
import FumehoodFaceVelocityScreen from '../screens/fumehood/calculations/FumehoodFaceVelocityScreen';
import FumehoodMultiPointAverageScreen from '../screens/fumehood/calculations/FumehoodMultiPointAverageScreen';
import FumehoodFaceAreaScreen from '../screens/fumehood/calculations/FumehoodFaceAreaScreen';
import FumehoodPressureDifferentialScreen from '../screens/fumehood/calculations/FumehoodPressureDifferentialScreen';

const Stack = createStackNavigator();

function useStackScreenOptions() {
  return {
    headerStyle: { backgroundColor: C.panel },
    headerTintColor: C.ink,
    headerTitleStyle: {
      fontFamily: FONT.sansBold,
      fontSize: 16,
      color: C.ink,
    },
    headerShadowVisible: false,
    headerBackTitleVisible: false,
    cardStyle: { backgroundColor: C.bg },
  };
}

export default function FumehoodNavigator() {
  const screenOptions = useStackScreenOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="FumehoodCalculations" component={FumehoodCalculationsScreen} options={{ title: 'Fume Hood Calculations' }} />
      <Stack.Screen name="FumehoodOverview" component={FumehoodOverviewScreen} options={{ title: 'Fume Hood Overview' }} />
      <Stack.Screen name="FumehoodTypes" component={FumehoodTypesScreen} options={{ title: 'Fume Hood Types' }} />
      <Stack.Screen name="FumehoodFaceVelocity" component={FumehoodFaceVelocityScreen} options={{ title: 'Face Velocity & CFM' }} />
      <Stack.Screen name="FumehoodMultiPointAverage" component={FumehoodMultiPointAverageScreen} options={{ title: 'Multi-Point Average' }} />
      <Stack.Screen name="FumehoodFaceArea" component={FumehoodFaceAreaScreen} options={{ title: 'Face Area' }} />
      <Stack.Screen name="FumehoodPressureDifferential" component={FumehoodPressureDifferentialScreen} options={{ title: 'Pressure Differential' }} />
    </Stack.Navigator>
  );
}
